export default {
  container: {
    marginBottom: "20px"
  }
};
